/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as Styles from '../../../../SharedModules/StyleConstant/StyleConstant';

import { cellRenderer,cellRendererFourDec } from '../../../../SharedModules/utilities/utilities';

function amountComparator(amount1, amount2) {
  let amt1 = null;
  let amt2 = null;
  if (amount1 && amount1?.toString()?.includes('$')) {
    amt1 = parseFloat(
      amount1?.toString().split('$')[1]?.toString()?.replace(',', '').trim()
    );
  } else {
    amt1 = parseFloat(amount1?.toString()?.replace(',', '').trim());
  }
  if (amount2 && amount2?.toString()?.includes('$')) {
    amt2 = parseFloat(
      amount2?.toString().split('$')[1]?.toString()?.replace(',', '').trim()
    );
  } else {
    amt2 = parseFloat(amount2?.toString()?.replace(',', '').trim());
  }
  if (amt1 === null && amt2 === null) {
    return 0;
  }
  if (amt1 === null) {
    return -1;
  }
  if (amt2 === null) {
    return 1;
  }

  return amt1 - amt2;
}
// For the proper sorting of quarter columns
const comparatorQtr = (a, b, nodeA, nodeB, isDescending) => {
  const splittedQtrA = a.split('Q');
  const splittedQtrB = b.split('Q');
  return splittedQtrA[1] - splittedQtrB[1] || splittedQtrA[0] - splittedQtrB[0];
};

export const AllManufacturer = [
  {
    headerName: 'Select All',
    // minWidth: Styles.Width_100,
    maxWidth: Styles.Width_150,
    headerCheckboxSelection: true, // For header check box
    checkboxSelection: true,
    filter: false,
    field: 'checkSelect',
    editable: false,
    suppressMenu: true,
    sortable: false,
    cellRenderer: 'GenericCodeTextBox',
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    cellStyle: { borderRightColor: Styles.BorderColor },
    custClass: 'tbill-rate-editable-input',
    pdfExportOptions: {
      skipColumn: true,
    },
  },
  {
    headerName: 'Manufacturer ID',
    field: 'mfgId',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_200,
    maxWidth: Styles.Width_200,
    cellRenderer: 'GenericCodeTextBox',
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    cellStyle: { borderRightColor: Styles.BorderColor },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Manufacturer Name',
    field: 'mfgName',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_120,
    cellRenderer: 'GenericCodeTextBox',
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    cellStyle: { borderRightColor: Styles.BorderColor },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const QuarterDisplay = [
  {
    headerName: 'Mfg ID',
    field: 'mfgId',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_100,
    cellRenderer: 'GenericCodeTextBox',
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    cellStyle: { borderRightColor: Styles.BorderColor },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Manufacturer Name',
    field: 'mfgName',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_280,
    cellRenderer: 'TextBoxRender',
    cellClass: 'frr-ellipsis-text',
    columnSpan: 3,

    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    cellStyle: { borderRightColor: Styles.BorderColor },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },

  {
    headerName: 'Quarter',
    field: 'qtr',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_120,
    cellRenderer: 'GenericCodeTextBox',
    comparator: comparatorQtr,
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    cellStyle: { borderRightColor: Styles.BorderColor },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Total Of NDCs',
    field: 'totalNdc',
    editable: false,
    suppressMenu: false,
    sortable: true,
    excelAlignment: 'right',
    minWidth: Styles.Width_160,
    comparator: amountComparator,
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    alignment: 'right',
    isTextColorRed: true,
  },
  {
    headerName: 'Total Units Disputed',
    field: 'totalDisputedUnits',
    editable: false,
    suppressMenu: false,
    excelAlignment: 'right',
    sortable: true,
    minWidth: Styles.Width_150,
    cellRenderer: cellRendererFourDec,
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    comparator: amountComparator,
    printPrefixValue: '',
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    alignment: 'right',
    isTextColorRed: true,
  },
  {
    headerName: 'Total Dollars Disputed',
    field: 'totalDisputedDollars',
    cellRenderer: cellRenderer,
    comparator: amountComparator,

    isTextColorRed: true,
    printPrefixValue: '$',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_180,
    // cellRenderer: 'GenericCodeTextBox',
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    alignment: 'right',
    isAmount: true,
  },
];
